
const headerData = (title) => {
    const headerVal = []
    headerVal[0] = title
    headerVal[1] = ''
    headerVal[2] = ''
    return headerVal
}

const excelBody = (vm) => {
    const excelData = []
    vm.report_data.forEach((items, index) => {
        const appItems = items
        appItems.forEach((element) => {
            const myObj = {}
            myObj[vm.$t('globalTrans.sl_no')] = vm.$n(index + 1)
            myObj[vm.$t('globalTrans.date')] = vm.$options.filters.dateFormat(element.date)
            myObj[vm.$t('rehabilitation_management.registration_id')] = '\'' + element.registration_id + '\''
            myObj[vm.$t('globalTrans.name')] = vm.$i18n.locale === 'en' ? element.name : element.name_bn
            myObj[vm.$t('rehabilitation_management.contact_no')] = '\'' + vm.$options.filters.mobileNumber(element.contact_no) + '\''
            myObj[vm.$t('rehabilitation_management.security_status')] = vm.$i18n.locale === 'en' ? element.security_status : element.security_status_bn
            myObj[vm.$t('globalTrans.remarks')] = vm.$i18n.locale === 'en' ? element.remarks : element.remarks_bn

            excelData.push(myObj)
        })
    })
    return excelData
}

export default {
    headerData,
    excelBody
}
